module.exports = __webpack_public_path__ + "static/and-the-truth-shall-set-you-free-a26e21c5d5b341d76ef7deb7f1f0cd52.jpg";